import React from 'react';
import TabledisenoCurricularAsignaturas from './TableDisenoCurricularAsignaturas/TableDisenoCurricularAsignaturas';

const DisenoCurricularAsignaturas = () => {
  return <TabledisenoCurricularAsignaturas/> ;
};

export default DisenoCurricularAsignaturas;
